import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'teacher-add-applies';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function storeDate({
  card_id,
  expire_days,
  expire_time,
  update_payment,
  update_remark,
}) {
  return post({
    url: `${url}/dates`,
    data: {
      card_id,
      expire_days,
      expire_time,
      update_payment,
      update_remark,
    },
  });
}

export function storeNumber({
  card_id,
  is_number_limit,
  expire_number,
  update_payment,
  update_remark,
}) {
  return post({
    url: `${url}/numbers`,
    data: {
      card_id,
      is_number_limit,
      expire_number,
      update_payment,
      update_remark,
    },
  });
}

export function storeType({
  store_ids,
  card_id,
  card_number,
  card_type_id,
  card_type_name,
  card_name,
  card_charge_type_id,
  is_number_limit,
  expire_number,
  expire_days,
  expire_time,
  store_limit_expire_days,
  store_limit_expire_time,
  update_remark,
  update_payment,
}) {
  return post({
    url: `${url}/types`,
    data: {
      store_ids,
      card_id,
      card_number,
      card_type_id,
      card_type_name,
      card_name,
      card_charge_type_id,
      is_number_limit,
      expire_number,
      expire_days,
      expire_time,
      store_limit_expire_days,
      store_limit_expire_time,
      update_remark,
      update_payment,
    },
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}/`,
    data,
  });
}
